// in case of changing device sizes update values in variables.css as well
export enum DeviceMaxSize {
  MOBILE = 600,
  TABLET_VERTICAL = 900,
  TABLET_HORIZONTAL = 1280,
}

export enum StorageKeys {
  FILTERS = 'filters',
  LAST_OPENED_TAB_INDEX = 'lastOpenedTabIndex',
  ALL_DATA_SELECTED_COLUMNS = 'allDataSelectedColumn',
  OPERATIONS_SELECTED_COLUMNS = 'operationsSelectedColumn',
  DEPARTMENTS_SELECTED = 'departmentsSelected',
  DEPARTMENT_RELATIONS = 'departmentRelations',
  HISTORY_ACTIVE = 'historyActive',
  HISTORY_ACCESSIBLE = 'historyAccessible',
}

export enum HeaderKeys {
  DEPARTMENTS_SELECTED = 'Departments-Selected',
}
